module.exports = __webpack_public_path__ + "img/tulgan.efbca92b.jpg";